/**
 * Reload the page the widget runs in.
 *
 * Test mode is a boot-time decision — the transport is chosen once in `init()`,
 * before the auth machine runs — so entering, leaving or restarting it takes
 * effect on the next page load and not before. There is deliberately no
 * mid-conversation transport swap.
 *
 * Wrapped so its three callers state that once, and so a test has a seam to stub
 * instead of redefining `window.location`.
 */
export function reloadPage(): void {
  window.location.reload();
}
